import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import Badge from '@/components/common/Badge.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import useDuration from '@/composables/useDuration'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useCourse from '@/composables/useCourse'
  import useBreakpoint from '@/composables/useBreakpoint'
  import type { CourseModule as CourseModuleState } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseModules',
  setup(__props) {

  const { durationIcon, lesson } = useIcons()
  const { formatDurationToHHMM } = useDuration()
  const { isDesktopDevice } = useBreakpoint()
  const { convertToRoman, closeModal } = useCommonMixin()
  const { isPurchasedCourse, courseModules, course, guidedQuizDuration } = useCourse()

  const filteredCourseModules = computed(() => {
    if (!course.value?.courseGroups?.length) {
      return {
        '': {
          name: '',
          modules: courseModules.value,
        },
      }
    }
    return course.value.courseGroups.reduce(
      (acc, group) => {
        acc[group.id] = {
          name: group.name,
          modules: courseModules.value?.filter((mod) => mod.courseGroupId === group.id) || [],
        }
        return acc
      },
      {} as { [key: string]: { name: string; modules: CourseModuleState[] } },
    )
  })

  const approximateModuleDuration = (module: CourseModuleState) => {
    const lessonDurations = module.lessons.map((lesson) => lesson.duration || 0)
    const totalLessonDuration = lessonDurations.reduce((total, duration) => total + duration, 0)

    const _guidedQuizDuration = module.guidedQuiz ? guidedQuizDuration.value(module.guidedQuiz.numberOfQuestions) : 0

    const totalDuration = totalLessonDuration + _guidedQuizDuration
    return formatDurationToHHMM(Math.round(totalDuration))
  }

return { __sfc: true,durationIcon, lesson, formatDurationToHHMM, isDesktopDevice, convertToRoman, closeModal, isPurchasedCourse, courseModules, course, guidedQuizDuration, filteredCourseModules, approximateModuleDuration, computed, Badge, SVGRenderer, HTMLRenderer, useIcons, useDuration, useCommonMixin, useCourse, useBreakpoint }
}

})